export default __webpack_public_path__ + "static/media/samplelandia.aff353b5.png";